import { useState, useEffect } from 'react';

const useHomeQuickModal = ({ onClose }) => {

  const submit = () => {
    
  }
  
  return {
    submit,
  };
};

export default useHomeQuickModal;